"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitButton = void 0;
const index_1 = require("../i18n/index");
const mithril_1 = require("../mithril");
const spinner_1 = require("./spinner/spinner");
exports.SubmitButton = {
    view(ctx) {
        return (0, mithril_1.m)('button', {
            className: `${ctx.className != null ? ctx.className : ''} mdl-button mdl-button--raised ${!ctx.noAccent ? 'mdl-button--accent' : ''}`,
            type: 'submit',
            disabled: (ctx.form != null && !ctx.form.canSubmit) || ctx.submitting || Boolean(ctx.disabled),
            onclick: () => {
                ctx.submit();
                return false;
            }
        }, ctx.submitting ? spinner_1.Spinner.view() : (0, index_1.Translate)(ctx.title));
    }
};
//# sourceMappingURL=submit.button.js.map